'use client';

import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

export default function HomeAnimator() {

  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add(
      {
        isDesktop: '(min-width: 768px)',
        isMobile: '(max-width: 767px)',
        isXl: '(min-width: 1280px)',
      },
      (context) => {
        // const { isDesktop, isMobile, isXl } = context.conditions!;
        // const isStupid = isIOS();


      },
    );
  }, []);

  return <></>;
}
